import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Count of contacts (profiles) where a partner submitted them and they are
 * awaiting staff approval (`partner_ownership_status = 'pending'`).
 *
 * Used by the sidebar to surface pending-approval work without requiring
 * the user to scroll the Contacts page. Skipped for partner users.
 */
export const usePendingPartnerContactsCount = (enabled: boolean = true) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["pending-partner-contacts-count", user?.id],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("profiles")
        .select("id", { count: "exact", head: true })
        .eq("partner_ownership_status", "pending");

      if (error) {
        console.error("Error fetching pending partner contacts count:", error);
        return 0;
      }
      return count ?? 0;
    },
    enabled: !!user && enabled,
    refetchInterval: 30000,
    staleTime: 15000,
  });
};